export const StoreProductType = {
  all: "全商品（一部季節商品を除く）",
  pajamas: "パジャマ",
  workWear: "ワークウェア",
  sandal: "サンダル",
  insole: "インソール",
  baby: "ベビー",
  accessory: "アクセサリー",
  sleep: "寝具",
} as const
export type StoreProductType = keyof typeof StoreProductType

export const StoreType = {
  official: "直営店",
  popup: "popup",
  sis: "SIS",
  agent: "販売代理店",
} as const
export type StoreType = keyof typeof StoreType
export const officialStore = ["official", "popup"]
export const dealerStore = ["sis", "agent"]

export const FilterStoreType = {
  official: "オフィシャルストア",
  dealer: "取扱店",
} as const
export type FilterStoreType = keyof typeof FilterStoreType

export const StoreScaleType = {
  large: "大規模",
  medium: "中規模",
  small: "小規模",
} as const
export type StoreScaleType = keyof typeof StoreScaleType

export const OthersSelectType = {
  dressingRoom: "試着室あり",
} as const
export type OthersSelectType = keyof typeof OthersSelectType
